// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Es-z","imageAndVideoCount":"Fs-z","imageAndVideoContainer":"Gs-z","viewAllReviews":"Hs-z"};